<template>
  <div id="app">

 <router-view />
  </div>
</template>

<script>
// import MainLayout from './components/MainLayout.vue'; // 确保路径正确

export default {
  components: {
    // MainLayout
  }
};
</script>

<style>
#app {
  height: 100vh;
  display: flex;
  flex-direction: column;
}
</style>
